export enum DocumentCategoryEnum {
  ID_USER = "ID_USER",
  ID_OWNER = "ID_OWNER",
  ID_SPOUSE = "ID_SPOUSE",
  SELFIE_OWNER = "SELFIE_OWNER",
  DEATH_CERTIFICATE = "DEATH_CERTIFICATE",
  INVENTORY = "INVENTORY",
  DILIGENCE = "DILIGENCE",
  LAWYER_ATTACHMENT = "LAWYER_ATTACHMENT",
  OFFICER_ACCEPTENCE_CONTRACT = "OFFICER_ACCEPTENCE_CONTRACT",
  OFFICER_CESSION_CONTRACT = "OFFICER_CESSION_CONTRACT",
  ADMIN_CESSION_CONTRACT = "ADMIN_CESSION_CONTRACT",
  OFFICER_INVOICE = "OFFICER_INVOICE",
  MARRIAGE_CERTIFICATE = "MARRIAGE_CERTIFICATE",
  LETTER_OF_ATTORNEY = "LETTER_OF_ATTORNEY",
  TED_RECEIPT = "TED_RECEIPT",
  RESIDENTIAL_CERTIFICATE = "RESIDENTIAL_CERTIFICATE",
  PUBLIC_DEED = "PUBLIC_DEED",
  PRIVATE_DEED = "PRIVATE_DEED",
  PUBLIC_DEED_SIGNATURE_MANIFEST = "PUBLIC_DEED_SIGNATURE_MANIFEST",
  RATIFICATION = "RATIFICATION",
  LEGAL_PROCESS = "LEGAL_PROCESS",
  COMPLIANCE = "COMPLIANCE",
  TICKET = "TICKET",
  PROOF_OF_RESIDENCE = "PROOF_OF_RESIDENCE",
  CLICK_SIGN_CONTRACT_ACCEPTENCE_TERM = "CLICK_SIGN_CONTRACT_ACCEPTENCE_TERM",
  CLICK_SIGN_CONTRACT_CESSION_TERM = "CLICK_SIGN_CONTRACT_CESSION_TERM",
  CLICK_SIGN_CONTRACT_OLD_CESSION_TERM = "CLICK_SIGN_CONTRACT_OLD_CESSION_TERM",
  ADMIN_ACCEPTENCE_CONTRACT = "ADMIN_ACCEPTENCE_CONTRACT",
  SPECIAL_PROJECT_DOCUMENT = "SPECIAL_PROJECT_DOCUMENT",
  MARRIAGE_PRENUPTIAL_AGREEMENT = "MARRIAGE_PRENUPTIAL_AGREEMENT",
  DIGITAL_CERTIFICATE = "DIGITAL_CERTIFICATE",

  FINANCIAL_DEPOSITADO_PARCIALMENTE = "FINANCIAL_DEPOSITADO_PARCIALMENTE",
  FINANCIAL_DEPOSITADO = "FINANCIAL_DEPOSITADO",
  FINANCIAL_PENDENTE = "FINANCIAL_PENDENTE",
  FINANCIAL_TRANSFERENCIA_APROVADA = "FINANCIAL_TRANSFERENCIA_APROVADA",
  FINANCIAL_PAGO_PARCIALMENTE = "FINANCIAL_PAGO_PARCIALMENTE",
  FINANCIAL_PAGO = "FINANCIAL_PAGO",
  FINANCIAL_LEVANTAMENTO_INDEVIDO = "FINANCIAL_LEVANTAMENTO_INDEVIDO",
  FINANCIAL_PENDENTE_PEC = "FINANCIAL_PENDENTE_PEC",
  FINANCIAL_FRAUDE = "FINANCIAL_FRAUDE",
  FINANCIAL_EM_ACORDO = "FINANCIAL_EM_ACORDO",
  FINANCIAL_PROVISIONADO = "FINANCIAL_PROVISIONADO",
  FINANCIAL_ALVARA_PROTOCOLIZADO = "FINANCIAL_ALVARA_PROTOCOLIZADO",
  FINANCIAL_CEDIDO = "FINANCIAL_CEDIDO",
  FINANCIAL_PERDA_TOTAL = "FINANCIAL_PERDA_TOTAL",
  FINANCIAL_PERDA_PARCIAL = "FINANCIAL_PERDA_PARCIAL",
  PROCESSING_RECONCILE = 'PROCESSING_RECONCILE',
  NEGATIVE_SPREAD = 'NEGATIVE_SPREAD',

  LEGAL_ACORDO_DIRETO_SOLICITADO = "LEGAL_ACORDO_DIRETO_SOLICITADO",
  LEGAL_ACORDO_DIRETO_PAGO = "LEGAL_ACORDO_DIRETO_PAGO",
  LEGAL_ACORDO_DIRETO_INDEFERIDO = "LEGAL_ACORDO_DIRETO_INDEFERIDO",
  LEGAL_ACORDO_DIRETO_HABILITADO = "LEGAL_ACORDO_DIRETO_HABILITADO",
  LEGAL_EXECUCAO_CONTRA_CEDENTE = "LEGAL_EXECUCAO_CONTRA_CEDENTE",
  LEGAL_ESTEIRA_COBRANCA = "LEGAL_ESTEIRA_COBRANCA",
  LEGAL_DUPLICIDADE_CESSAO = "LEGAL_DUPLICIDADE_CESSAO",

  LEGAL_PROTOCOLADO = "LEGAL_PROTOCOLADO",
  LEGAL_NAO_PROTOCOLADO = "LEGAL_NAO_PROTOCOLADO",
  LEGAL_CESSAO_INDEFERIDO = "LEGAL_CESSAO_INDEFERIDO",
  LEGAL_RECURSO_INTERPOSTO = "LEGAL_RECURSO_INTERPOSTO",
  LEGAL_HOMOLOGADO = "LEGAL_HOMOLOGADO",
  LEGAL_COM_ALVARA = "LEGAL_COM_ALVARA",

  EXPEDITION_TYPE_PRE_PRECATORIO = "EXPEDITION_TYPE_PRE_PRECATORIO",
  EXPEDITION_TYPE_PRECATORIO_EXPEDIDO = "EXPEDITION_TYPE_PRECATORIO_EXPEDIDO",
  EXPEDITION_TYPE_LOA_REGISTRATION = "EXPEDITION_TYPE_LOA_REGISTRATION",

  PROCURACAO_AD_JUDICIA_PRIVADA = "PROCURACAO_AD_JUDICIA_PRIVADA",
  PROCURACAO_AD_JUDICIA_PUBLICA = "PROCURACAO_AD_JUDICIA_PUBLICA",
  CERTIFICATE_DISTRIBUTION = "CERTIFICATE_DISTRIBUTION",
  CERTIFICATE_OF_WORK_IN_PROCESSING = "CERTIFICATE_OF_WORK_IN_PROCESSING",
  CERTIFICATE_ELECTRONIC_OF_LABOR_ACTIONS = "CERTIFICATE_ELECTRONIC_OF_LABOR_ACTIONS",
  CERTIFICATE_OF_DISTRIBUTION_OF_ACTIONS_CRIMINAIS_ON_LINE = "CERTIFICATE_OF_DISTRIBUTION_OF_ACTIONS_CRIMINAIS_ON_LINE",
  CERTIFICATE_PROCESSES_DISTRIBUTED_TRF = "CERTIFICATE_PROCESSES_DISTRIBUTED_TRF",
  CERTIFICATE_PGNF_ECAC = "CERTIFICATE_PGNF_ECAC",
  CONTRACT_HONORARIOS = "CONTRACT_HONORARIOS",
  PREFERRED_INSTALMENT = "PREFERRED_INSTALMENT",

  PRECATORIO_CASE_FILE = "PRECATORIO_CASE_FILE",
  PGFN = "PGFN",
  CNDT = "CNDT",
  CNDT_STATE = "CNDT_STATE",
  SPC = "SPC",
  FRAUD_REPORT = "FRAUD_REPORT",
  LEGAL_OPINION = 'LEGAL_OPINION',
  DEBTS_REPORT = 'DEBTS_REPORT',
  DILIGENCE_REPORT = 'DILIGENCE_REPORT',
  BANK_DATA_CERTIFICATE = 'BANK_DATA_CERTIFICATE',
  OFICIO = 'OFICIO',
  ATTORNEY_FEES_REPORT = 'ATTORNEY_FEES_REPORT',
  OWNER_DEBTS_REPORT = 'OWNER_DEBTS_REPORT',
  SPOUSE_DEBTS_REPORT = 'SPOUSE_DEBTS_REPORT',
  CALCULATION_BASE = 'CALCULATION_BASE',
  CARD_CNPJ = 'CARD_CNPJ',
  CONTRACT_SOCIAL_UPDATED = 'CONTRACT_SOCIAL_UPDATED',
  PROOF_OF_REGISTRATION_OAB = 'PROOF_OF_REGISTRATION_OAB',
  PROOF_COPY_OF_ADDRESS = 'PROOF_COPY_OF_ADDRESS',
  PROOF_OF_BANK_DATA = 'PROOF_OF_BANK_DATA',
  DOCUMENT_IDENTITY = 'DOCUMENT_IDENTITY',
  CERTIFICATE_COPY_OF_ADDRESS_PARTNES = 'CERTIFICATE_COPY_OF_ADDRESS_PARTNES',
  PROOF_OF_STATUS_MARITAL = 'PROOF_OF_STATUS_MARITAL',
  BALANCE_RESULTS = 'BALANCE_RESULTS',
  IVENTORY = 'IVENTORY',
  BIRTH_CERTIFICATE = 'BIRTH_CERTIFICATE',
  COPY_PROCESS = 'COPY_PROCESS',
  COPY_OF_RECORDS = 'COPY_OF_RECORDS',
  COPY_OF_ENFORCEMENT_SENTENCE = 'COPY_OF_ENFORCEMENT_SENTENCE',
  P2_EVIDENCE = 'P2_EVIDENCE'
}

export const DocumentCategoryLabel = new Map<DocumentCategoryEnum, string>([
  [DocumentCategoryEnum.ID_USER, "ID Usuário"],
  [DocumentCategoryEnum.ID_OWNER, "Identidade do Cliente"],
  [DocumentCategoryEnum.ID_SPOUSE, "Identidade do Conjuge"],
  [DocumentCategoryEnum.SELFIE_OWNER, "Selfie Cliente"],
  [DocumentCategoryEnum.DEATH_CERTIFICATE, "Certidão de Óbito"],
  [DocumentCategoryEnum.INVENTORY, "Inventário"],
  [DocumentCategoryEnum.DILIGENCE, "Diligência"],
  [DocumentCategoryEnum.LAWYER_ATTACHMENT, "Anexo de Advogado"],
  [DocumentCategoryEnum.OFFICER_ACCEPTENCE_CONTRACT, "Termo de Aceite via Officer"],
  [DocumentCategoryEnum.OFFICER_CESSION_CONTRACT, "Termo de Cessão via Officer"],
  [DocumentCategoryEnum.ADMIN_CESSION_CONTRACT, "Termo de Cessão via Admin"],
  [DocumentCategoryEnum.OFFICER_INVOICE, "Invoice"],
  [DocumentCategoryEnum.MARRIAGE_CERTIFICATE, "Certidão de Casamento"],
  [DocumentCategoryEnum.LETTER_OF_ATTORNEY, "Procuração"],
  [DocumentCategoryEnum.TED_RECEIPT, "Recibo TED"],
  [DocumentCategoryEnum.RESIDENTIAL_CERTIFICATE, "Certidão de Residência"],
  [DocumentCategoryEnum.PUBLIC_DEED, "Escritura Publica"],
  [DocumentCategoryEnum.PUBLIC_DEED_SIGNATURE_MANIFEST, "Manifesto de assinatura da escritura pública"],
  [DocumentCategoryEnum.RATIFICATION, "Rerratificação"],
  [DocumentCategoryEnum.LEGAL_PROCESS, "Processo Legal"],
  [DocumentCategoryEnum.COMPLIANCE, "Compliance"],
  [DocumentCategoryEnum.TICKET, "Ticket"],
  [DocumentCategoryEnum.PROOF_OF_RESIDENCE, "Comprovante de Endereço"],
  [DocumentCategoryEnum.CLICK_SIGN_CONTRACT_ACCEPTENCE_TERM, "Termo de Aceite (Click Sign)"],
  [DocumentCategoryEnum.CLICK_SIGN_CONTRACT_CESSION_TERM, "Antigo Termo de Cessão (Click Sign)"],
  [DocumentCategoryEnum.CLICK_SIGN_CONTRACT_OLD_CESSION_TERM, "Novo Termo de Cessão (Click Sign)"],
  [DocumentCategoryEnum.ADMIN_ACCEPTENCE_CONTRACT, "Contrato de Aceite via Admin"],
  [DocumentCategoryEnum.SPECIAL_PROJECT_DOCUMENT, "Documento de Projeto Especial"],
  [DocumentCategoryEnum.MARRIAGE_PRENUPTIAL_AGREEMENT, "Pacto Antenupcial"],
  [DocumentCategoryEnum.DIGITAL_CERTIFICATE, "Certificado Digital"],

  [DocumentCategoryEnum.FINANCIAL_DEPOSITADO_PARCIALMENTE, "Evidencia Status Depositado Parcialmente"],
  [DocumentCategoryEnum.FINANCIAL_DEPOSITADO, "Evidencia Status Financeiro Depositado"],
  [DocumentCategoryEnum.FINANCIAL_PENDENTE, "Evidencia Status Financeiro Pendente"],
  [DocumentCategoryEnum.FINANCIAL_TRANSFERENCIA_APROVADA, "Evidencia Status Financeiro Transferência aprovada"],
  [DocumentCategoryEnum.FINANCIAL_PAGO_PARCIALMENTE, "Andamento do processo ou extrato do depósito"],
  [DocumentCategoryEnum.FINANCIAL_PAGO, "Andamento do processo ou extrato do depósito"],
  [DocumentCategoryEnum.FINANCIAL_PAGO_PARCIALMENTE, "Evidenca status Financeiro pago parcialmente"],
  [DocumentCategoryEnum.FINANCIAL_PENDENTE_PEC, "Evidencia status Financeiro Pendente(EC 113 E 114)"],
  [DocumentCategoryEnum.FINANCIAL_LEVANTAMENTO_INDEVIDO, "Evidencia status Financeiro Levantamento indevido"],

  [DocumentCategoryEnum.FINANCIAL_FRAUDE, "Evidencia status Financeiro fraude"],
  [DocumentCategoryEnum.FINANCIAL_EM_ACORDO, "Evidencia status Financeiro em acordo"],
  [DocumentCategoryEnum.FINANCIAL_PROVISIONADO, "Evidencia status Financeiro provisionado"],
  [DocumentCategoryEnum.FINANCIAL_ALVARA_PROTOCOLIZADO, "Evidencia status Financeiro Alvará protocolizado"],
  [DocumentCategoryEnum.FINANCIAL_CEDIDO, "Evidencia status Financeiro cedido"],
  [DocumentCategoryEnum.FINANCIAL_PERDA_TOTAL, "Evidencia status Financeiro Perda total"],
  [DocumentCategoryEnum.FINANCIAL_PERDA_PARCIAL, "Evidencia status Financeiro Perda parcial"],
  [DocumentCategoryEnum.FINANCIAL_EM_ACORDO, "Evidencia do acordo em andamento"],
  [DocumentCategoryEnum.FINANCIAL_CEDIDO, "Evidencia da cessão"],
  [DocumentCategoryEnum.FINANCIAL_PERDA_TOTAL, "Evidencia da perda total"],
  [DocumentCategoryEnum.FINANCIAL_PERDA_PARCIAL, "Evidencia da perda parcial"],
  [DocumentCategoryEnum.FINANCIAL_ALVARA_PROTOCOLIZADO, "Evidencia alvará protocolizado"],

  [DocumentCategoryEnum.LEGAL_NAO_PROTOCOLADO, "Evidencia Status Jurídico Não protocolado"],
  [DocumentCategoryEnum.LEGAL_PROTOCOLADO, "Evidencia Status Jurídico Protocolado"],
  [DocumentCategoryEnum.LEGAL_CESSAO_INDEFERIDO, "Evidencia Status Jurídico Cessão indeferida"],
  [DocumentCategoryEnum.LEGAL_RECURSO_INTERPOSTO, "Evidencia Status Jurídico Recurso interposto"],
  [DocumentCategoryEnum.LEGAL_HOMOLOGADO, "Andamento do processo ou despacho"],
  [DocumentCategoryEnum.LEGAL_COM_ALVARA, "Evidencia Status Jurídico Com alvará"],
  [DocumentCategoryEnum.LEGAL_ACORDO_DIRETO_SOLICITADO, "Evidencia Acordo direto solicitado"],
  [DocumentCategoryEnum.LEGAL_ACORDO_DIRETO_PAGO, "Evidencia Acordo direto pago"],
  [DocumentCategoryEnum.LEGAL_ACORDO_DIRETO_INDEFERIDO, "Evidencia Acordo direto indeferido"],
  [DocumentCategoryEnum.LEGAL_ACORDO_DIRETO_HABILITADO, "Evidencia Acordo direto habilitado"],
  [DocumentCategoryEnum.LEGAL_EXECUCAO_CONTRA_CEDENTE, "Evidencia execução contra o cedente"],
  [DocumentCategoryEnum.LEGAL_ESTEIRA_COBRANCA, "Evidencia da esteira de Cobrança"],
  [DocumentCategoryEnum.LEGAL_DUPLICIDADE_CESSAO, "Evidencia da duplicidade de cessão"],

  [DocumentCategoryEnum.EXPEDITION_TYPE_PRE_PRECATORIO, "Evidencia Pré precatório"],
  [DocumentCategoryEnum.EXPEDITION_TYPE_PRECATORIO_EXPEDIDO, "Ofício"],
  [DocumentCategoryEnum.EXPEDITION_TYPE_LOA_REGISTRATION, "Andamento do processo ou Printscreen da LOA"],
  [DocumentCategoryEnum.PROCURACAO_AD_JUDICIA_PRIVADA, "Procuração AD Judicia Privada"],
  [DocumentCategoryEnum.PROCURACAO_AD_JUDICIA_PUBLICA, "Procuração AD Judicia Publica"],
  [DocumentCategoryEnum.CERTIFICATE_DISTRIBUTION, "Certidão de Distribuição"],
  [DocumentCategoryEnum.CERTIFICATE_OF_WORK_IN_PROCESSING, "Certidão de ação trabalhista em tramitação"],
  [DocumentCategoryEnum.CERTIFICATE_ELECTRONIC_OF_LABOR_ACTIONS, "Certidão eletrônica de ações trabalhista"],
  [DocumentCategoryEnum.CERTIFICATE_OF_DISTRIBUTION_OF_ACTIONS_CRIMINAIS_ON_LINE, "Certidão de Distribuição de ações criminais Online"],
  [DocumentCategoryEnum.CERTIFICATE_PROCESSES_DISTRIBUTED_TRF, "Certidão processos distribuídos TRF"],
  [DocumentCategoryEnum.CERTIFICATE_PGNF_ECAC, "Certidão PGNF/E-CAC"],
  [DocumentCategoryEnum.CONTRACT_HONORARIOS, "Contratos de honorários"],
  [DocumentCategoryEnum.PREFERRED_INSTALMENT, "Alvará/Comprovante Parcela Preferencial já recebida"],
  [DocumentCategoryEnum.PRIVATE_DEED, "Instrumento de cessao particular"],

  [DocumentCategoryEnum.PRECATORIO_CASE_FILE, "Autos do precatorio"],
  [DocumentCategoryEnum.PGFN, "Certidão PGFN"],
  [DocumentCategoryEnum.CNDT, "Certidao negativa de debitos trabalhistas"],
  [DocumentCategoryEnum.CNDT_STATE, "Certidao negativa de debitos trabalhistas estaduais"],
  [DocumentCategoryEnum.SPC, "Certidão SPC"],
  [DocumentCategoryEnum.FRAUD_REPORT, "Relatorio de fraude"],
  [DocumentCategoryEnum.BANK_DATA_CERTIFICATE, 'Comprovante de dados bancarios'],
  [DocumentCategoryEnum.DILIGENCE_REPORT, 'Relatorio de diligencia'],
  [DocumentCategoryEnum.LEGAL_OPINION, 'Opiniao jurídica'],
  [DocumentCategoryEnum.DEBTS_REPORT, 'Relatorio de dividas'],
  [DocumentCategoryEnum.FRAUD_REPORT, 'Relatorio de fraude'],
  [DocumentCategoryEnum.OFICIO, 'Ofício requisitório'],
  [DocumentCategoryEnum.ATTORNEY_FEES_REPORT, 'Contrato de honorários'],
  [DocumentCategoryEnum.OWNER_DEBTS_REPORT, 'Relatorio de dividas do cedente',],
  [DocumentCategoryEnum.SPOUSE_DEBTS_REPORT, 'Relatorio de dividas do cônjuge'],
  [DocumentCategoryEnum.CALCULATION_BASE, 'Base de cálculo'],

  [DocumentCategoryEnum.CARD_CNPJ, 'Cartão CNPJ'],
  [DocumentCategoryEnum.CONTRACT_SOCIAL_UPDATED, 'Contrato social atualizado'],
  [DocumentCategoryEnum.PROOF_OF_REGISTRATION_OAB, 'Comprovante de registro na OAB'],
  [DocumentCategoryEnum.PROOF_COPY_OF_ADDRESS, 'Cópia do comprovante de endereço recente em nome da empresa'],
  [DocumentCategoryEnum.PROOF_OF_BANK_DATA, 'Comprovante de dados bancários da empresa'],
  [DocumentCategoryEnum.DOCUMENT_IDENTITY, 'Documento de identidade de sócios-administradores atualizado (RG, CPF OU CNH)'],
  [DocumentCategoryEnum.CERTIFICATE_COPY_OF_ADDRESS_PARTNES, 'Cópia do comprovante de endereço recente em nome dos sócios'],
  [DocumentCategoryEnum.PROOF_OF_STATUS_MARITAL, 'Comprovante de estado civil dos sócios'],
  [DocumentCategoryEnum.BALANCE_RESULTS, 'Balanços e demonstrações de resultados da empresa'],
  [DocumentCategoryEnum.IVENTORY, 'Iventário'],
  [DocumentCategoryEnum.BIRTH_CERTIFICATE, 'Certidão de nascimento'],
  [DocumentCategoryEnum.COPY_PROCESS, 'Cópia processo'],
  [DocumentCategoryEnum.COPY_OF_RECORDS, 'Cópia dos Autos'],
  [DocumentCategoryEnum.COPY_OF_ENFORCEMENT_SENTENCE, 'Cópia cumprimento de senteça'],
  [DocumentCategoryEnum.P2_EVIDENCE, 'Evidência de ativação de P2']
]);
